import * as React from 'react'
import {Link} from "gatsby";

const Overlay = () => {
    return (
        <div className="ort">
            <div className="information">
                <div className="image" id="image">
                    <img alt="" className="ort-img dummy" src={"/images/Logo_ODD.svg"}/>                
                </div>
                <div className="row">
                    <div className="col-12">
                        <h2>
                            Wunsiedel
                        </h2>
                    </div>
                </div>
                <p>
                    Vorbildliches zivilgesellschaftliches Engagement gegen Rechtsextremismus (Rudolf-Heß-Gedenkmärsche), aus dem 2005 die Bürgerinitiative „Wunsiedel ist bunt“ entstand.
                </p>
            </div>
                <Link to="/neue-Orte/" className='ort-text icon-arrow-right load-infobox'>
                Mehr erfahren
            </Link>

        </div>
    )
}

export default Overlay

